import React, {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from "react"

/**
 * Run (run_id) page filter context.
 * Holds only computed filter counts for the run results table.
 * Actual mutation and metric filter state lives in RunResultsTable (useLocalStorage).
 */

interface RunFilterContextType {
  /** Number of filters from this context (e.g. for badge). Run results table adds its own mutation + metric counts. */
  totalActiveFilters: number
  hasActiveFilters: boolean
}

const RunFilterContext = createContext<RunFilterContextType | undefined>(
  undefined,
)

interface RunFilterProviderProps {
  children: ReactNode
}

export const RunFilterProvider: React.FC<RunFilterProviderProps> = ({
  children,
}) => {
  const value = useMemo<RunFilterContextType>(
    () => ({
      totalActiveFilters: 0,
      hasActiveFilters: false,
    }),
    [],
  )

  return (
    <RunFilterContext.Provider value={value}>
      {children}
    </RunFilterContext.Provider>
  )
}

export const useRunFilterContext = () => {
  const context = useContext(RunFilterContext)
  if (context === undefined) {
    throw new Error(
      "useRunFilterContext must be used within a RunFilterProvider",
    )
  }
  return context
}
